

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.5","height":"8.357"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('path', {"fill":"#262626","d":"M3.111 2.983a.4.4 0 0 0-.565 0L.283 5.246a.4.4 0 0 0 0 .565l.007.006 2.256 2.257a.4.4 0 0 0 .565-.566l-1.979-1.98 1.98-1.98a.4.4 0 0 0 0-.565Z"}, []), h('path', {"stroke":"#262626","stroke-linecap":"round","d":"M8 .5v3a2 2 0 0 1-2 2H1"}, [])])]);
};

        